import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router"
import { ClienteLogin } from '../../../views/login/cliente_login';
import { UbicacionEntity, UbicacionEntityEmpresa } from "../../../views/masivos/datosGenerales/entities/ubicacion_entity";
import { CIUDADES } from "../cabecera/entity/ciudades";
import { Cliente, ClienteXCiudad } from "../../../views/login/cliente_login";
import { HandleError } from "../utils/handleError.component";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { UsuarioLoginEntity } from "../../../views/login/usuario_login_entity";
import { CabeceraEmpresaService } from "./cabecera-empresa.service";
import { Menu } from 'primeng/components/menu/menu';


declare var jQuery: any;

@Component({
    selector: 'cabeceraEmpresa',
    templateUrl: 'cabecera-empresa.template.html',
    styleUrls: ["cabecera-empresa.style.css"]
})

export class CabeceraEmpresa implements OnInit {
    inicial: number;
    usuario: ClienteLogin;
    comboCiudad: UbicacionEntityEmpresa[];
    lengthCombo: boolean;
    NombreUsuario: string;
    @SessionStorage("usuarioEmpresa")
    usuarioEmpresa: ClienteXCiudad
    usuarioObserve: ClienteXCiudad;

    constructor(private handleError: HandleError,private sessionStorageService: SessionStorageService, private cabeceraEmpresaService: CabeceraEmpresaService) { }

    ngOnInit() {
        this.inicial = 0;
        this.usuarioObserve = new ClienteXCiudad();
        try {
            this.usuario = jQuery.parseJSON(this.sessionStorageService.retrieve("usuario"));
            this.cargaTodo();
        } catch (e) {
            this.usuario = this.sessionStorageService.retrieve("usuario");
            this.cargaTodo();
        }

        this.sessionStorageService.observe("usuario").subscribe(v => {
            try {
                this.usuario = jQuery.parseJSON(v);
                this.cargaTodo();
            } catch (e) {
                this.usuario = v;
                this.cargaTodo();
            }
        });
    }

    cargaTodo() {
        let usuarioempresaretrive = new ClienteXCiudad();
        this.lengthCombo = this.usuario.Empresa.length > 1 ? true : false;
        this.comboCiudad = [];
        this.usuario.Empresa.forEach(element => {
            CIUDADES.forEach(a => {
                if (a.Codigo == element.Ciudad) {
                    let ubicacionMasCliente = new UbicacionEntityEmpresa();
                    ubicacionMasCliente.Codigo = element.CodigoCliente;
                    ubicacionMasCliente.Nombre = a.Nombre;
                    ubicacionMasCliente.Descripcion = element.Nombre;
                    this.comboCiudad.push(ubicacionMasCliente);
                }
            });
        });
        if (this.usuarioEmpresa == null) {
            this.usuarioEmpresa = this.usuario.Empresa[0];
            this.inicial = this.usuario.Empresa[0].CodigoCliente;
            this.cargaNombre(this.usuarioEmpresa);
        } else {
            try {
                usuarioempresaretrive = JSON.parse(this.sessionStorageService.retrieve("usuarioEmpresa"));
                this.inicial = usuarioempresaretrive.CodigoCliente;
                this.cargaNombre(usuarioempresaretrive);
            } catch (e) {
                usuarioempresaretrive = this.sessionStorageService.retrieve("usuarioEmpresa");
                this.inicial = usuarioempresaretrive.CodigoCliente;
                this.cargaNombre(usuarioempresaretrive);
            }
        }

    }

    cargaNombre(empresa: ClienteXCiudad) {
        this.NombreUsuario = empresa.Nombre;
    }

    onCiudadChange(codCliente) {
        this.usuario.Empresa.forEach(element => {
            if (element.CodigoCliente == codCliente) {
                let dup_array = new ClienteLogin();
                dup_array = JSON.parse(JSON.stringify(this.usuario));
                this.cabeceraEmpresaService.getMenuXCliente(element, this.usuario.Empresa, this.usuario.Cedula, this.usuario.CodigoUsuario).subscribe(a => {
                    dup_array.Menu = a;
                    if(this.isEmptyObject(dup_array.Menu)){
                        dup_array.Menu = null;
                    }
                    this.sessionStorageService.store("usuario", JSON.stringify(dup_array));
                }, error => {
                    this.handleError.redirectUrl(error);
                });
                this.sessionStorageService.store("usuarioEmpresa", JSON.stringify(element));
            }
        });
    }

    isEmptyObject(obj) {
        return (obj && (Object.keys(obj).length === 0));
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceraEmpresa/cabecera-empresa.component.ts